import { BoxProps, Icon, Stack, Text } from '@chakra-ui/react';
import { XCircleIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

type Props = BoxProps;

/**
 * ErrorQueryCard.
 * Full width stack for error on data fetching.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function ErrorQueryCard({ ...props }: Props): JSX.Element {
  const i18nErrorQueryCard = useTranslations('ErrorQueryCard');

  return (
    <Stack layerStyle="emptyState" {...props}>
      <Icon as={XCircleIcon} boxSize="40px" color="gray.400" />
      <Stack alignItems="center" spacing="0">
        <Text>{i18nErrorQueryCard('Title')}</Text>
        <Text>{i18nErrorQueryCard('SubTitle')}</Text>
      </Stack>
    </Stack>
  );
}

export type ErrorQueryCardProps = Props;
